import { ajax } from "@/assets/js/ajax";
export function list(data) {    //权限列表
  return ajax({
    url: 'menu/tree',
    type: 'get',
    data: data
  })
}

export function setPower(data, type) {  //权限增加
  return ajax({
    url: type == 1 ? 'menu/add' : 'menu/update',
    type: type == 1 ? 'post' : 'put',
    data: data,
    contentType: 'application/json'
  })
}


export function powerDel(data) {  //权限删除
  return ajax({
    url: 'menu/delete?id=' + data,
    type: 'delete'
  })
}
